import { Product } from "../../entity/Product";
import { toDate } from "../../utils/GlobalFunctions";
import { ProductDTO } from "../dto/Product.Dto";

export const mapToProduct = (productDTO: ProductDTO[]): Product[] => {
  return productDTO.map((productDTO) => {
    return {
      id: productDTO.id,
      discount: productDTO.discount,
      updatedAt: toDate(productDTO.updatedAt),
      ref: productDTO.ref,
      quantity: productDTO.quantity,
      imageUrl: productDTO.imageUrl,
      price: productDTO.price,
      description: productDTO.description,
      name: productDTO.name,
      createdAt: toDate(productDTO.createdAt),
      inStock: productDTO.inStock,
      deliveryPrice: productDTO.deliveryPrice,
      productCost: productDTO.productCost,
      storeId: productDTO.storeId,
      packName: productDTO.packName,
      packs: productDTO.packs,
    };
  });
};
